import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, accountActions, eventActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { eventModalViews, postActions, analyticsTracking } from '../../../utils/constants';

const DeleteFutureIncomeTextContainer = styled.div`
  margin: 32px 0 56px;
`;

const DeleteFutureIncomeText = styled.span`
  font-family: 'Nimbus Sans Light';
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

const PlanName = styled.span`
  font-family: Nimbus Sans Bold;
  font-weight: bold;
  font-size: 20px;
  color: ${tokens.ColorGrey900};
`;

class DeleteFutureExpenseModal extends Component<any> {
  props: any;
  state: any;

  handleDelete = () => {
    const {
      updateEventsData,
      events,
      // events: { selectedEvent },
    } = this.props;

    const tempEvents = [...events?.tempScenario?.events];
    tempEvents[events.selectedEvent.eventIndex] = { ...events.selectedEvent, action: postActions.DELETE };
    updateEventsData({ events: tempEvents });

    this.returnToFutureIncome();
  };

  returnToFutureIncome = () => {
    const { showModal } = this.props;
    showModal(eventModalViews.FUTURE_INCOME_MODAL);
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 768px)');
    const { events } = this.props;
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle="Delete Expense" showClose={true} />
        <ReactModalContent>
          <DeleteFutureIncomeTextContainer>
            <DeleteFutureIncomeText>
              Deleting this entry will permanently remove it from your retirement projections. You might want to exclude it instead so you can access it in the future.
            </DeleteFutureIncomeText>
            <br />
            <br />
            <PlanName>Delete {events.selectedEvent.name}?</PlanName>

            {/* {mq.matches ? (
              <PlanName>Delete {selectedFutureIncome.name}?</PlanName>
            ) : (
              <>
                <DeleteFutureIncomeText>
                  Delete <PlanName>{selectedFutureIncome.name}</PlanName>?
                </DeleteFutureIncomeText>{' '}
              </>
            )} */}
          </DeleteFutureIncomeTextContainer>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Delete"
          buttonType="alert"
          handleCancelClick={this.returnToFutureIncome}
          handleCTAClick={this.handleDelete}
          CTAButtonId={analyticsTracking.RIXDeleteFutureExpenseModalActionDelete}
          CancelButtonId={analyticsTracking.RIXDeleteFutureExpenseModalActionCancel}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ incomeEvents, account, events, riScenario }: any) => ({
  incomeEvents: incomeEvents.data,
  events,
  account,
  riScenario,
});

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  updateEventsData: eventActions.updateIncomeEventData,
},
)(DeleteFutureExpenseModal);
